package floris.graphics.landing.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.pointerEvents
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import floris.graphics.core.constants.Res
import floris.graphics.core.navigation.Navigation
import com.materialdesignsystem.components.sections.BaseHeader
import com.materialdesignsystem.components.sections.NavigationItem
import com.materialdesignsystem.components.sections.OverflowMenu
import com.materialdesignsystem.components.svg.overflowMenuSvg
import com.materialdesignsystem.constants.Constants
import com.materialdesignsystem.toColorScheme
import floris.graphics.landing.components.widgets.Socials
import kotlinx.browser.window
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A

@Composable
fun LandingHeader(
    showMenuItems: Boolean,
    onMenuClicked: () -> Unit
) {
    val breakpoint = rememberBreakpoint()
    val colorMode by ColorMode.currentState
    val ctx = rememberPageContext()

    BaseHeader(
        backgroundColor = colorMode.toColorScheme.background
    ) {
        Row(
            modifier = Modifier.margin(left = 24.px),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            if (breakpoint < Breakpoint.MD && showMenuItems) {
                overflowMenuSvg(
                    modifier = Modifier
                        .margin(right = 24.px)
                        .cursor(Cursor.Pointer)
                        .onClick {
                            onMenuClicked()
                        },
                    fill = colorMode.toColorScheme.onBackground
                )
            }

            A(
                href = Navigation.Screen.Home.route,
                attrs = {
                    onClick {
                        ctx.router.navigateTo(Navigation.Screen.Home.route)
                    }
                }
            ) {
                Image(
                    modifier = Modifier
                        .height(Constants.HEADER_COLLAPSED_LOGO_HEIGHT.px),
                    src = Res.Image.logo,
                    alt = "Logo Image"
                )
            }
        }

        if (breakpoint >= Breakpoint.MD) {
            if (showMenuItems) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .pointerEvents(PointerEvents.None) // Make sure this element does not prohibit any pointer events (or clicks)
                        .position(Position.Absolute),
                    horizontalArrangement = Arrangement.Center
                ) {
                    NavigationItems(
                        modifier = Modifier.pointerEvents(PointerEvents.Auto),
                        row = true
                    )
                }
            }

            Socials(modifier = Modifier.fillMaxWidth().margin(right = 24.px))
        }
    }
}

@Composable
fun LandingOverflowMenu(
    onMenuClosed: () -> Unit
) {
    OverflowMenu(
        logoImage = "/logo.svg",
        onMenuClosed = onMenuClosed
    ) {
        Column {
            NavigationItems(row = false)

            Socials(modifier = Modifier.fillMaxWidth().margin(top = 36.px))
        }
    }
}

@Composable
fun NavigationItems(modifier: Modifier = Modifier, row: Boolean = true) {
    NavigationItem(
        modifier = modifier
            .margin(
                right = if (row) 30.px else 0.px,
                bottom = if (!row) 16.px else 0.px
            ),
        title = "Home",
        href = Navigation.Screen.Home.route
    ) {
        window.scrollTo(0.0, 0.0)
    }

    NavigationItem(
        modifier = modifier,
        title = "Contact",
        href = Navigation.Screen.Home.contactFragment
    )
}